import { Navigate } from 'react-router-dom'
import { useAuth } from '../../core/auth'

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) return null
  if (!user) return <Navigate to="/login" replace />
  if (user.role !== 'admin') return <Navigate to="/lng-ops" replace />
  return <>{children}</>
}
